import { LoadingButton } from '@mui/lab';
import { Button, DialogContent, Skeleton, Stack, Table, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import call from 'src/core/services/http';
import Iconify from 'src/shared/components/Iconify';
import Label from 'src/shared/components/Label';
import Scrollbar from 'src/shared/components/Scrollbar';
import useLocalStorage from 'src/shared/hooks/useLocalStorage';
import { CustomDialog, CustomDialogTitle } from 'src/shared/sharebles/items';
import ListHead from 'src/shared/TableComponents/ListHead';
import { CustomCell, CustomRow } from 'src/shared/TableComponents/TableStyles';
import { useStyles } from 'src/shared/Text/zoomeffect';
import { flattenObject } from 'src/shared/utils/flattenObject';
import { fDateTime } from 'src/shared/utils/formatTime';
import { fDateDMY } from 'src/shared/utils/formatTime';


const TABLE_HEAD = [
    { id: 'id', label: "ID", alignLeft: true },
    { id: 'external_account_name', label: "Student Name", alignLeft: true },
    { id: 'external_account_number', label: "Student Nemis Number", alignLeft: true },
    { id: 'institution_account_name', label: "School Name", alignLeft: true },
    { id: 'institution_account_number', label: "School Account Number", alignLeft: true },
    { id: 'payer_name', label: "Parent Name", alignLeft: true },
    { id: 'payer_mobile_no', label: " Parent Mobile Number", alignLeft: true },
    { id: 'amount', label: "Amount", alignLeft: true },
    { id: 'channel_code', label: "Channel", alignLeft: true },
    { id: 'reference', label: "Payment Reason", alignLeft: true },
    { id: 'status', label: " Status", alignLeft: true },
    { id: 'created_at', label: "Date", alignLeft: true },


];


export default function ViewBeneficiaries({ escrow_status, id }) {
    const zoom = useStyles();
    const [orders, setOrders] = useState({
        current_page: 0,
        page_size: 10,
        results: [],
        pages: 0,
        page: 0,
        count: 0
    })

    const [shop] = useLocalStorage('shop-details')

    const { results, current_page, pages, page, count, page_size, pagescount } = orders

    const newItems = [];

    results?.forEach(element => {
        newItems.push(flattenObject(element))
    });

    // /cdf-payments/45/process/upload-payment-wages/
    // <int:pk>/process/upload-payment-wages/instituion/</int:pk>

    // useEffect(() => {
    //     const fetchData = async () => {
    //         setWorking(true)
    //         const resp = await call('get', `/cdf-payments/${id}/process/upload-payment-wages/instituion/?account_number=${shop.account_number}`).catch(e => {
    //             setWorking(false)
    //             toast.error(e.response.data.message);
    //         })
    //         setWorking(false)

    //         if (resp.status === 200) {
    //             const response = resp.data

    //             if (response.status) {
    //                 setOrders({
    //                     ...orders,
    //                     ...response,
    //                     page,
    //                     page_size,
    //                 })
    //                 // toast.success(response.message)
    //             } else {
    //                 toast.error(response.message)
    //             }
    //         }
    //     };

    //     const intervalId = setInterval(fetchData, 40000);

    //     // Cleanup function to clear the interval on component unmount
    //     return () => {
    //         clearInterval(intervalId);
    //     };
    // }, [page, page_size]);

    // useEffect(() => {
    //     getRecords(page, page_size)
    // }, [])


    const [beneficiaries, setBeneficiaries] = useState([])

    const getBeneficiaries = async () => {
        try {
            const response = await call('get', `/cdf-payments/${id}/process/upload-payment-wages/instituion/?account_number=${shop.account_number}`);
            if (response.data.status) {
                setBeneficiaries(response.data.result.bulk_uploads_details);
                // setIsLoading(false);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getBeneficiaries();
    }, []);


    const [order, setOrder] = useState('asc');

    const [orderBy, setOrderBy] = useState('account_name');

    const [selected, setSelected] = useState([]);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = results.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const [item, setItem] = useState({ transaction_code: '' });

    const [open, setOpen] = useState(false);

    const [working, setWorking] = useState(false)

    const reset = () => {
        setOpen(false)
        setItem({ ...item, transaction_code: '' })
        setWorking(false)
        getBeneficiaries(0, page_size)
    }

    const onPageChange = (e, page) => {
        setOrders({ ...orders, page })
        getBeneficiaries(page, page_size)
    }

    const onRowsPerPageChange = (event) => {
        setOrders({ ...orders, page: 0, page_size: parseInt(event.target.value, 10) })

        getBeneficiaries(page, parseInt(event.target.value, 10))
    }


    // function RowComponent({ row, index }) {

    //     const [working, setWorking] = useState(false)


    //     const { id, amount, created_at, payer_mobile_no,payer_name,beneficiary_account_account_number,beneficiary_account_description, description, status, external_account_number, external_account_name } = row
    //     return (
    //         <CustomRow hover key={id}>
    //             <CustomCell>
    //                 {index}
    //             </CustomCell>
    //             <CustomCell>
    //                 <Typography className={zoom.zoomIn}>{external_account_name}</Typography>
    //             </CustomCell>
    //             <CustomCell>
    //                 <Typography className={zoom.zoomIn}> {external_account_number}</Typography>
    //             </CustomCell>
    //             <CustomCell>
    //                 {beneficiary_account_description}
    //             </CustomCell>
    //             <CustomCell>
    //                 {beneficiary_account_account_number}
    //             </CustomCell>
    //             <CustomCell>
    //                 {payer_name}
    //             </CustomCell>
    //             <CustomCell>
    //                 {payer_mobile_no}
    //             </CustomCell>
    //             <CustomCell>
    //                 {description}
    //             </CustomCell>
    //             <CustomCell>
    //                 {amount}
    //             </CustomCell>
    //             <CustomCell>
    //                 {getStatus(status)}
    //             </CustomCell>
    //             <CustomCell>
    //                 {fDateTime(created_at)}
    //             </CustomCell>

    //         </CustomRow>
    //     )
    // }
    return (
        <>

            <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                    <Table>
                        <ListHead
                            order={order}
                            orderBy={orderBy}
                            headLabel={TABLE_HEAD}
                            numSelected={selected.length}
                            onRequestSort={handleRequestSort}
                            onSelectAllClick={handleSelectAllClick}
                        />
                        <TableBody>
                            {beneficiaries?.map((beneficary, index) => {
                                const rowNumber = index + 1;
                                return (
                                    <CustomRow hover key={index}>
                                        <CustomCell>{rowNumber}</CustomCell>
                                        <CustomCell>{beneficary?.external_account_name}</CustomCell>
                                        <CustomCell>{beneficary?.external_account_number}</CustomCell>
                                        <CustomCell>{beneficary?.institution_account_name}</CustomCell>
                                        <CustomCell>{beneficary?.institution_account_number}</CustomCell>
                                        <CustomCell>{beneficary?.payer_name}</CustomCell>
                                        <CustomCell>{beneficary?.payer_mobile_no}</CustomCell>
                                        <CustomCell>{beneficary?.amount}</CustomCell>
                                        <CustomCell>{beneficary?.channel_code}</CustomCell>
                                        <CustomCell>{beneficary?.reference}</CustomCell>
                                        <CustomCell>{beneficary?.status === 0 ? <Label color='success'>Pending</Label> : <Label color='error'>Successfull</Label>}</CustomCell>
                                        <CustomCell>{fDateDMY(beneficary?.created_at)}</CustomCell>
                                    </CustomRow>
                                );
                            })}
                        </TableBody>

                        {/* <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={count}
                    onPageChange={onPageChange}
                    page={page}
                    rowsPerPage={page_size}
                    onRowsPerPageChange={onRowsPerPageChange}
                /> */}
                    </Table>
                </TableContainer>

            </Scrollbar>

        </>
    );
}

const statuses = [
    {
        text: "Awaiting Approval",
        color: 'error'
    },
    {
        text: "Ready For Disbursement ",
        color: 'warning'
    },
    {
        text: "Successfully Processed",
        color: 'success'
    },

]

const getStatus = (status) => {
    return <Label color={statuses[status].color} variant='filled'>{statuses[status].text}</Label>
}